// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__lM1Qc","map_title_style":"MapPOIS_map_title_style__fl6Vb"};